module.exports = "@import url(\"https://fonts.googleapis.com/css?family=Material+Icons\");\n"